module.exports = __webpack_public_path__ + "img/MitDemRückenZurWand.ec27c722.jpg";